import { AppointmentV2 } from '../../utils/types';

export default {
  setAppointments: (payload: AppointmentV2[]) =>
    ({ type: 'appointments_v2/setAppointments', payload }) as const,
};
